<template>
    <div class="background" v-if="showLoadingMask">
        <div class="loadingCenter">

            <div class="animzone">
                <div class="animblock1"></div>
                <div class="animblock2"></div>
                <div class="animblock3"></div>
                <div class="animblock4"></div>
                <div class="animblock5"></div>
                <div class="animblock6"></div>
                <div class="animblock7"></div>
                <div class="animblock8"></div>
                <div class="animblock9"></div>
                <div class="animblock10"></div>
            </div>

        </div>
        <span class="currentState"> {{ loadingMaskMessage }}</span>
    </div>
</template>

<script lang="ts">
    import { Vue } from 'vue-property-decorator';
    import Component from 'vue-class-component';
    import { Getter } from 'vuex-class';

    /** Masque de chargement de l'application */
    @Component({ name: 'loadingmask' })
    export default class LoadingMask extends Vue {
		/** Indique si le masque de chargement est affiché ou non */
		@Getter('GetShowLoadingMask')
		private showLoadingMask!: boolean;

        /** Message affiché dans le masque */
        @Getter("GetLoadingMaskMessage")
        private loadingMaskMessage!: string;
    }
</script>

<style scoped>
    .background {
        position: fixed;
        display: flex;
        flex-direction: column;
        vertical-align: central;
        justify-content: center;
        align-content: center;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        background-color: rgba(128,128,128,0.5);
        z-index: 2000;
    }

    .loadingCenter {
        width: 400px;
        height: 200px;
        align-self: center;
        display: flex;
        flex-direction: column;
        vertical-align: central;
        justify-content: center;
        border-radius: 3px;
    }

    .currentState {
        color: #0db2b0;
        vertical-align: central;
        justify-content: center;
        align-content: center;
        align-self: center;
        display: block;
        font-weight: bold;
        font-size: 1rem;
        height: 30px;
        line-height: 30px;
        vertical-align: middle;
        text-align: center;
        min-width: 400px;
        transform: translateY(-115px);
        /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+0,ffffff+100&0+0,0.65+33,0.65+66,0+100 */
        background: -moz-linear-gradient(left, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 33%, rgba(255,255,255,1) 66%, rgba(255,255,255,0) 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(left, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 33%,rgba(255,255,255,1) 66%,rgba(255,255,255,0) 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 33%,rgba(255,255,255,1) 66%,rgba(255,255,255,0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#00ffffff',GradientType=1 ); /* IE6-9 */
        border-radius: 3px;
    }

    .animzone {
        display: flex;
        flex-direction: row;
        width: 300px;
        height: 120px;
        background-color: transparent;
        align-self: center;
        padding: 10px;
    }

    .animblock1,
    .animblock2,
    .animblock3,
    .animblock4,
    .animblock5,
    .animblock6,
    .animblock7,
    .animblock8,
    .animblock9,
    .animblock10 {
        display: inline-block;
        width: 5%;
        height: 110px;
        margin-left: 2.5%;
        margin-right: 2.5%;
        background-color: transparent;
        align-self: center;
        animation: loading5 4.5s infinite ease-in-out;
    }

    .animblock1 {
        animation-delay: -1.5s;
    }

    .animblock2 {
        animation-delay: -1.4s;
    }

    .animblock3 {
        animation-delay: -1.3s;
    }

    .animblock4 {
        animation-delay: -1.2s;
    }

    .animblock5 {
        animation-delay: -1.1s;
    }

    .animblock6 {
        animation-delay: -1.0s;
    }

    .animblock7 {
        animation-delay: -0.9s;
    }

    .animblock8 {
        animation-delay: -0.8s;
    }

    .animblock9 {
        animation-delay: -0.7s;
    }

    .animblock10 {
        animation-delay: -0.6s;
    }

    @keyframes loading5 {
        0% {
            height: 0px;
            margin-bottom: 0;
            background: transparent;
            align-self: center;
            border-radius: 50px;
        }

        16.5% {
            height: 100%;
            margin-bottom: 0;
            background: #0b506d;
            align-self: center;
            border-radius: 3px;
        }

        32.99% {
            height: 0px;
            margin-bottom: 0;
            background: transparent;
            align-self: center;
            border-radius: 50px;
        }

        33% {
            height: 0px;
            margin-bottom: 0;
            background: transparent;
            align-self: center;
            border-radius: 50px;
        }

        50% {
            height: 100%;
            margin-bottom: 0;
            background: #bfce69;
            align-self: center;
            border-radius: 3px;
        }

        66.6% {
            height: 0px;
            margin-bottom: 0;
            background: transparent;
            align-self: center;
            border-radius: 50px;
        }

        66.7% {
            height: 0px;
            margin-bottom: 0;
            background: transparent;
            align-self: center;
            border-radius: 50px;
        }

        89% {
            height: 100%;
            margin-bottom: 0;
            background: #15afbf;
            align-self: center;
            border-radius: 3px;
        }

        99.9% {
            height: 0px;
            margin-bottom: 0;
            background: transparent;
            align-self: center;
            border-radius: 50px;
        }
    }
</style>